export default __webpack_public_path__ + "static/media/geometric2.6ad34bf4.jpg";